export default __webpack_public_path__ + "static/media/learning.3243e379.png";